import React, { useEffect, useState } from 'react'
import ThemeBanner from './EventLibrary/themeBanner';
import { Heading } from '../RecogntionAdmin/styles';
import { ImageUrl } from '../../utils/constants';
import { GetRecommendedEventData, GetFeaturedAndUpcomingOnsiteEvent, OnSiteEventCategories } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import EventsCategory from './EventLibrary/EventsCategory';
import CompanyOragnizedCategory  from './EventLibrary/CompanyOrganizedCategory'
import { AdminCategoriesNew, LaunchIcon, StarIconSmall,GraphIconSmall } from '../../utils/icons';
import Thumbnail from '../Thumbnail';
import { EventCard, FlexWrapper, NewChampionsCard, NewContentV2, NewVideoPlayer } from '../MainEvents/RecommendEventVideos/styles';
import { Layout, Container } from "../MainEvents/CompanyLiveEvents/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CompanyCard } from "../MainEvents/CompanyLiveEvents/styles";
import { NewBackArrowIconEventPage, NewNextArrowIconEventPage, DatePickerIconUserEvents, PeopleIconForRegisteredUsers } from '../../utils/icons'
import moment from "moment";
import { convertDateInTimezone } from "../../utils/methods";
import { ReservedButton, SliderContainer } from "../MainEvents/styles";
import LazyImage from "../common/LazyImage/LazyImage";
import parse from 'react-html-parser';

// Custom Next Arrow Component with PropTypes
const NextArrow = ({ currentSlide, slideCount, onClick }) => {
  const isLastSlide = currentSlide === slideCount - 1;
  if (isLastSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-next"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

NextArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

// Custom Prev Arrow Component with PropTypes
const PrevArrow = ({ currentSlide, onClick }) => {
  const isFirstSlide = currentSlide === 0;
  if (isFirstSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-prev"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

PrevArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

const EventLibrary = ({ history, companyId }) => {
  const [RecommendedEventData, setRecommendedEventData] = React.useState([]);
  const [onSiteCategories,setOnSiteCategories]= useState([]);
  const [FeaturedAndUpcomingEvents, setFeaturedAndUpcomingEvents] = useState({});
  const [onHover, setOnHover]=useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, setSliderRef] = useState(null);
  const [currentFeaturedSlide, setCurrentFeaturedSlide] = useState(0);
  const [featuredSliderRef, setFeaturedSliderRef] = useState(null);
  const [loadingFeaturedAndUpcoming, setLoadingFeaturedAndUpcoming] = useState(false);
  const [apiError, setApiError] = useState(false);

  useEffect(() => {
    !RecommendedEventData.length && GetRecommendedEvents(companyId);
  }, []);

  useEffect(()=>{
    GetOnsiteCategories()
    GetFeaturedAndUpcomingEvents();
  },[])

  const onEnterMouse = (id) => {
    setOnHover(id)
  }

  const onLeaveMouse = () => {
    setOnHover(-1)
  };

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
  };

  const handleFeaturedBeforeChange = (oldIndex, newIndex) => {
    setCurrentFeaturedSlide(newIndex);
  };

  // Get current month events from FeaturedAndUpcomingEvents
  const currentMonthEvents = Array.isArray(FeaturedAndUpcomingEvents?.current_month) 
    ? FeaturedAndUpcomingEvents.current_month.slice(0, 5) 
    : [];
  
  // Get upcoming month events from FeaturedAndUpcomingEvents
  const upcomingMonthEvents = Array.isArray(FeaturedAndUpcomingEvents?.upcoming_month) 
    ? FeaturedAndUpcomingEvents.upcoming_month.slice(0, 3) 
    : [];

  const companyLive = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <NextArrow currentSlide={currentSlide} slideCount={currentMonthEvents.length} />,
    prevArrow: <PrevArrow currentSlide={currentSlide} />,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={currentMonthEvents.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={currentMonthEvents.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
    ],
  };

  const featuredEventSettings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <NextArrow currentSlide={currentFeaturedSlide} slideCount={Array.isArray(RecommendedEventData) ? RecommendedEventData.length : 0} />,
    prevArrow: <PrevArrow currentSlide={currentFeaturedSlide} />,
    beforeChange: handleFeaturedBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentFeaturedSlide} slideCount={Array.isArray(RecommendedEventData) ? RecommendedEventData.length : 0} />,
          prevArrow: <PrevArrow currentSlide={currentFeaturedSlide} />,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentFeaturedSlide} slideCount={Array.isArray(RecommendedEventData) ? RecommendedEventData.length : 0} />,
          prevArrow: <PrevArrow currentSlide={currentFeaturedSlide} />,
        },
      },
    ],
  };

  const convertMonthFromDate = (dateString) => {
    if (!dateString) return '';
    const temp = dateString.split(" ");
    return temp.join(" ");
  };

  const GetOnsiteCategories = async()=>{
    let category_type = "theme"
    let apiUrl = OnSiteEventCategories + "/"  + category_type;
    try{
      const res = await fetchApi(apiUrl, "GET");
      if(res.status === "success"){
        setOnSiteCategories(res.data || []);
      }else{
        toast.error(res.message);
      }
    }catch(error){
      toast.error(error)
    }
  }

  const GetFeaturedAndUpcomingEvents = async()=>{
    setLoadingFeaturedAndUpcoming(true);
    setApiError(false);
    
    try{
      const res = await fetchApi(GetFeaturedAndUpcomingOnsiteEvent, "GET");
      if(res && res.status === "success"){
        // API response has current_month and upcoming_month arrays
        setFeaturedAndUpcomingEvents({
          current_month: Array.isArray(res.data?.current_month) ? res.data.current_month : [],
          upcoming_month: Array.isArray(res.data?.upcoming_month) ? res.data.upcoming_month : []
        });
      } else {
        toast.error(res.error || "Failed to load upcoming events");
        setFeaturedAndUpcomingEvents({ current_month: [], upcoming_month: [] });
      }
    }catch(error){
      toast.error(error);
      setApiError(true);
      setFeaturedAndUpcomingEvents({ current_month: [], upcoming_month: [] });
    } finally {
      setLoadingFeaturedAndUpcoming(false);
    }
  }

  const GetRecommendedEvents = async (companyId) => {
    const apiUrl = GetRecommendedEventData + (companyId && "/" + companyId);
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setRecommendedEventData(Array.isArray(res?.data) ? res.data : []);
      } else {
        toast.error(res.error);
        setRecommendedEventData([]); // Set to empty array on error
      }
    } catch (error) {
      window.console.error(error);
      setRecommendedEventData([]); // Set to empty array on error
    }
  };

  const featuredAndUpcomingEventsRedirection = (data) => {
    history.push({pathname:`/company/events/create`,state:{isCustomizedEvent:true,eventId:data?.id, title: data?.title, image: data?.image, description: data?.description}});
  };
  const upComingEventsRedirection = (id) => {
    history.replace({pathname:`/company/events/create-lunch-learns`,state:{isOnDemandEvent:true,eventId:id}});
  };

  return (
    <>
      <ThemeBanner/>
      
      {/* Featured Themed Events Section - Show current_month data */}
      {currentMonthEvents.length > 0 && (
        <Layout style={{background:'#fff', border:'0.75px solid #DCDCDC'}} margin={"20px 0 5px 0"} padding={"20px 20px 30px 20px"} background={'#fff'} >
          <div className="headingMain">
            <div style={{ gap: "12px" }} className="heading">
              <div style={{display: 'flex', alignItems: 'center'}}>
                {StarIconSmall("#184A61")}
              </div>
              {"Featured Celebration Events"}
            </div>
            {currentMonthEvents.length > 1 ? (
              <div className="arrows">
                <div
                  className="iconBackground"
                  onClick={() => sliderRef?.slickPrev()}
                  style={{ 
                    opacity: currentSlide === 0 ? 0 : 1,
                    cursor: currentSlide === 0 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {NewBackArrowIconEventPage()}
                </div>
                <div className="text">
                  {currentSlide + 1} / {currentMonthEvents.length}
                </div>
                <div
                  className="iconBackground"
                  onClick={() => currentSlide < currentMonthEvents.length - 1 && sliderRef?.slickNext()}
                  style={{ 
                    opacity: currentSlide === currentMonthEvents.length - 1 ? 0 : 1,
                    cursor: currentSlide === currentMonthEvents.length - 1 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {NewNextArrowIconEventPage()}
                </div>
              </div>
            ) : null}
          </div>
          <Container>
            {currentMonthEvents.length > 0 && (
              <SliderContainer
                display="flex"
                content="center"
                shadow="0px 8px 25px 0px #0D427040"
              >
                <Slider
                  {...companyLive}
                  ref={(slider) => setSliderRef(slider)}
                >
                  {currentMonthEvents.map((data, index) => (
                    <div className="card featCard" key={index} style={{paddingRight:'0', marginRight:'-30px !important'}}>
                      <CompanyCard
                        className="featChallanges" 
                        detailsCardPadding="0 0 10px 20px"
                        width="1248px"
                        onClick={() => history.push({pathname:`/company/events/create`,state:{isCustomizedEvent:true,eventId:data?.id, title: data?.title, image: data?.image, description: data?.description}})}
                      >
                        <LazyImage
                          div={"imageCard featImg"} style={{borderRadius:'8px 0  0 8px'}}
                          src={`${ImageUrl}/${data.image}`}
                          alt="category"
                        />
                        <div className="detailsCard" style={{border:'0.75px solid #DCDCDC',padding:'0 20px 20px 20px',borderRadius:'0 8px 8px 0',borderLeft:'0'}}>
                          <div className="title">
                            {data?.title}
                          </div>
                          <div className="description" style={{paddingTop:'20px'}}>
                            {parse(data?.description || "")}
                          </div>
                          {data.start_date && (
                            <div className="date">
                              <div className="icon">
                                <DatePickerIconUserEvents />
                              </div>
                              <div className="detail">
                                {convertMonthFromDate(
                                  moment(
                                    convertDateInTimezone(data?.start_date)._d
                                  ).format("MMM D, YYYY | hh:mm A")
                                )}
                                {!data.is_all_day_event && data.end_date && 
                                  ` IST - ${moment(
                                    convertDateInTimezone(data?.end_date)._d
                                  ).format("MMM D, YYYY | hh:mm A")} IST`
                                }
                              </div>
                            </div>
                          )}
                          {data?.attendees_list?.length > 0 && data.event_type !== "theme" ? (
                            <div className="date">
                              <div className="icon">
                                <PeopleIconForRegisteredUsers />
                              </div>
                              <div className="detail">
                                {data?.attendees_list?.length} Registered{" "}
                                {data?.attendees_list?.length > 1 ? "Users" : "User"}
                              </div>
                            </div>
                          ) : null}

                          {data?.event_participants_count > 0 && data.event_type === "theme" ? (
                            <div className="date">
                              <div className="icon">
                                <PeopleIconForRegisteredUsers />
                              </div>
                              <div className="detail">
                                {data?.event_participants_count} joined{" "}
                                {data?.event_participants_count > 1 ? "users" : "user"}
                              </div>
                            </div>
                          ) : null}

                          <div className="moving-btn" style={{"marginTop":"auto","width":"100%","display":"flex","WebkitBoxPack":"center","justifyContent":"center","WebkitBoxAlign":"center","alignItems":"center","gap":"16px"}}>
                            <ReservedButton 
                              active={true} 
                              width="268px" 
                              height="40px"
                              onClick={() => history.push({pathname:`/company/events/create`,state:{isCustomizedEvent:true,eventId:data?.id, title: data?.title, image: data?.image, description: data?.description}})}
                            >
                              <div  style={{marginRight: "8px"}}>{"Launch Event"}</div>
                            </ReservedButton>
                          </div>
                        </div>
                      </CompanyCard>
                    </div>
                  ))}
                </Slider>
              </SliderContainer>
            )}
          </Container>
        </Layout>
      )}

      {/* Upcoming Month Featured Themed Events Section - Show upcoming_month data */}
      {loadingFeaturedAndUpcoming ? (
        <Heading>
          <div className='icon' style={{marginRight:'4px'}}>
            {GraphIconSmall("#184A61")}
          </div>
          Upcoming Celebration Events
          <span style={{ fontSize: '14px', color: '#666', marginLeft: '10px' }}>
            Loading...
          </span>
        </Heading>
      ) : apiError ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          Unable to load upcoming events. Please try again later.
        </div>
      ) : upcomingMonthEvents.length > 0 ? (
        <>
          <Heading>
            <div className='icon' style={{marginRight:'4px'}}>
              {GraphIconSmall("#184A61")}
            </div>
            Upcoming Celebration Events  
          </Heading>
          
          <FlexWrapper>
            {upcomingMonthEvents.map((item, id) => (
              <NewChampionsCard key={id}>
                <EventCard
                  onMouseEnter={() => onEnterMouse(item.id)}
                  onMouseLeave={() => onLeaveMouse()}>
                  <NewVideoPlayer>
                    <Thumbnail
                      style={{ cursor: 'default' }} 
                      src={`${ImageUrl}/${item?.thumbnail_image || item?.image}`}
                      alt={'img'}
                    />
                  </NewVideoPlayer>
                  {onHover === item.id &&
                    <div className='educateImageBackground'  onClick={()=>featuredAndUpcomingEventsRedirection(item)}>
                      <div className="getStarted">
                        {LaunchIcon()}
                        {("Launch Event")}
                      </div>
                    </div>
                  }
                  <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto' }}>
                    <div className='firstContainer'>
                      <div className='name' title={item?.title}>
                        {item?.title}
                      </div>
                      {item.start_date && (
                        <div className='date' style={{marginTop: '8px', fontSize: '12px', color: '#666'}}>
                          {convertMonthFromDate(
                            moment(
                              convertDateInTimezone(item?.start_date)._d
                            ).format("MMM D, YYYY | hh:mm A")
                          )}
                        </div>
                      )}
                    </div>
                  </NewContentV2>
                </EventCard>
              </NewChampionsCard>
            ))}
          </FlexWrapper>
        </>
      ) : null}

      {Array.isArray(onSiteCategories) && onSiteCategories.length > 0 ? <>
        <Heading>
          <div className='icon' style={{marginRight:'4px'}}>
            {AdminCategoriesNew("#184A61")}
          </div>
          Celebration Events
        </Heading>
        <CompanyOragnizedCategory history={history} onSiteCategories={onSiteCategories}/></> : null}
      
      
      {/* Featured Event of the Month Section with same arrow functionality */}
      {Array.isArray(RecommendedEventData) && RecommendedEventData.length > 0 && (
        <Layout style={{background:'#fff',border:'0.75px solid #DCDCDC'}} margin={"20px 0 5px 0"} padding={"20px 20px 30px 20px"} background={'#fff'} >
          <div className="headingMain">
            <div style={{ gap: "12px" }} className="heading">
              <div style={{display: 'flex', alignItems: 'center'}}>
                {StarIconSmall("#184A61")}
              </div>
              {"Featured Event of the Month"}
            </div>
            {RecommendedEventData.length > 1 ? (
              <div className="arrows">
                <div
                  className="iconBackground"
                  onClick={() => featuredSliderRef?.slickPrev()}
                  style={{ 
                    opacity: currentFeaturedSlide === 0 ? 0 : 1,
                    cursor: currentFeaturedSlide === 0 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {NewBackArrowIconEventPage()}
                </div>
                <div className="text">
                  {currentFeaturedSlide + 1} / {RecommendedEventData.length}
                </div>
                <div
                  className="iconBackground"
                  onClick={() => currentFeaturedSlide < RecommendedEventData.length - 1 && featuredSliderRef?.slickNext()}
                  style={{ 
                    opacity: currentFeaturedSlide === RecommendedEventData.length - 1 ? 0 : 1,
                    cursor: currentFeaturedSlide === RecommendedEventData.length - 1 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {NewNextArrowIconEventPage()}
                </div>
              </div>
            ) : null}
          </div>
          <Container>
            {RecommendedEventData.length > 0 && (
              <SliderContainer
                display="flex"
                content="center"
                shadow="0px 8px 25px 0px #0D427040"
              >
                <Slider
                  {...featuredEventSettings}
                  ref={(slider) => setFeaturedSliderRef(slider)}
                >
                  {RecommendedEventData.map((data, index) => (
                    <div className="card featCard" key={index} style={{paddingRight:'0', marginRight:'-30px !important'}}>
                      <CompanyCard
                        className="featChallanges" 
                        detailsCardPadding="0 0 10px 20px"
                        width="1248px"
                        onClick={() => upComingEventsRedirection(data?.id)}
                      >
                        <LazyImage
                          div={"imageCard featImg"} style={{borderRadius:'8px 0  0 8px',borderRight:'0', border:'0.75px solid #DCDCDC'}}
                          src={`${ImageUrl}/${data.thumbnail_image}`}
                          alt="category"
                        />
                        <div className="detailsCard" style={{border:'0.75px solid #DCDCDC',padding:'0 20px 20px 20px',borderRadius:'0 8px 8px 0',borderLeft:'0'}}>
                          <div className="title">
                            {data?.title}
                          </div>
                          <div className="description" style={{paddingTop:'20px'}}>
                            {parse(data?.description || '')}
                          </div>
                          {data.start_date && (
                            <div className="date">
                              <div className="icon">
                                <DatePickerIconUserEvents />
                              </div>
                              <div className="detail">
                                {convertMonthFromDate(
                                  moment(
                                    convertDateInTimezone(data?.start_date)._d
                                  ).format("MMM D, YYYY | hh:mm A")
                                )}
                                {!data.is_all_day_event && data.end_date && 
                                  ` IST - ${moment(
                                    convertDateInTimezone(data?.end_date)._d
                                  ).format("MMM D, YYYY | hh:mm A")} IST`
                                }
                              </div>
                            </div>
                          )}
                          {data?.attendees_list?.length > 0 && data.event_type !== "theme" ? (
                            <div className="date">
                              <div className="icon">
                                <PeopleIconForRegisteredUsers />
                              </div>
                              <div className="detail">
                                {data?.attendees_list?.length} Registered{" "}
                                {data?.attendees_list?.length > 1 ? "Users" : "User"}
                              </div>
                            </div>
                          ) : null}

                          {data?.event_participants_count > 0 && data.event_type === "theme" ? (
                            <div className="date">
                              <div className="icon">
                                <PeopleIconForRegisteredUsers />
                              </div>
                              <div className="detail">
                                {data?.event_participants_count} joined{" "}
                                {data?.event_participants_count > 1 ? "users" : "user"}
                              </div>
                            </div>
                          ) : null}

                          <div className="moving-btn" style={{"marginTop":"auto","width":"100%","display":"flex","WebkitBoxPack":"center","justifyContent":"center","WebkitBoxAlign":"center","alignItems":"center","gap":"16px"}}>
                            <ReservedButton 
                              active={true} 
                              width="268px" 
                              height="40px"
                              onClick={() => upComingEventsRedirection(data?.id)}
                            >
                              <div  style={{marginRight: "8px"}}>{"Launch Event"}</div>
                            </ReservedButton>
                          </div>
                        </div>
                      </CompanyCard>
                    </div>
                  ))}
                </Slider>
              </SliderContainer>
            )}
          </Container>
        </Layout>
      )}

      <Heading>
        <div className='icon' style={{marginRight:'4px'}}>
          {AdminCategoriesNew("#184A61")}
        </div>
        Woliba Wellness Events
      </Heading>
      <EventsCategory history={history}/>
    </>
  )
}

EventLibrary.propTypes = {
  history: PropTypes.object,
  companyId:PropTypes.number,
  role: PropTypes.string,
}

export default connect(null,null)(withTranslation()(EventLibrary));